module.exports = __webpack_public_path__ + "img/cat-head.7f8b8bc3.png";